import { useRef } from "react";
import { Calendar } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { TimeSelect } from "@/components/TimeSelect";

type DateTimeInputProps = {
  id: string;
  label?: string;
  value: string; // "yyyy-MM-ddTHH:mm"
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
};

export function DateTimeInput({ id, label, value, onChange, error, disabled }: DateTimeInputProps) {
  const [datePart, timePart] = value.split("T");
  const dateInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="space-y-1.5">
      {label && <Label htmlFor={id}>{label}</Label>}
      <div className="flex items-center gap-2 flex-wrap">
        <Input
          ref={dateInputRef}
          id={id}
          type="date"
          value={datePart ?? ""}
          onChange={(e) => onChange(`${e.target.value}T${timePart || "00:00"}`)}
          disabled={disabled}
          fullWidth={false}
          endIcon={<Calendar />}
          onEndIconClick={() => dateInputRef.current?.showPicker?.()}
          // Native calendar icon's hitbox can't be reliably aligned with a fixed overlay
          // (it shifts with padding), so hide it and drive the picker via endIcon instead.
          className="w-40 [&::-webkit-calendar-picker-indicator]:hidden"
        />
        <TimeSelect
          value={timePart || "00:00"}
          onChange={(t) => onChange(`${datePart ?? ""}T${t}`)}
          disabled={disabled}
        />
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
